import { SetupPermission } from 'src/app/core/interfaces';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const Administrative: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['users-roles', 'portal2', 'webhooks-management'],
  productLineLabel: 'administrative',
  hidePath: true,
});
